import {
    ABOUT_US_HELMET_TITLE,
    ABOUT_US_HELMET_DESCRIPTION,
    ABOUT_HERO_EYEBROW,
    ABOUT_HERO_TITLE,
    ABOUT_HERO_SUBTITLE,
    ABOUT_HERO_CTA_PRIMARY,
    ABOUT_HERO_CTA_SECONDARY,
    ABOUT_STATS_YEARS_VALUE,
    ABOUT_STATS_YEARS_LABEL,
    ABOUT_STATS_FAMILIES_VALUE,
    ABOUT_STATS_FAMILIES_LABEL,
    ABOUT_STATS_SERVICES_VALUE,
    ABOUT_STATS_SERVICES_LABEL,
    ABOUT_STATS_LANGUAGES_VALUE,
    ABOUT_STATS_LANGUAGES_LABEL,
    ABOUT_STORY_EYEBROW,
    ABOUT_STORY_TITLE,
    ABOUT_STORY_P1,
    ABOUT_STORY_P2,
    ABOUT_STORY_P3,
    ABOUT_STORY_IMAGE_ALT,
    ABOUT_VALUES_EYEBROW,
    ABOUT_VALUES_TITLE,
    ABOUT_VALUES_SUBTITLE,
    ABOUT_VALUE_TRUST_TITLE,
    ABOUT_VALUE_TRUST_DESC,
    ABOUT_VALUE_BILINGUAL_TITLE,
    ABOUT_VALUE_BILINGUAL_DESC,
    ABOUT_VALUE_FAMILY_TITLE,
    ABOUT_VALUE_FAMILY_DESC,
    ABOUT_VALUE_EXPERTISE_TITLE,
    ABOUT_VALUE_EXPERTISE_DESC,
    ABOUT_WHY_EYEBROW,
    ABOUT_WHY_TITLE,
    ABOUT_WHY_ITEM1, ABOUT_WHY_ITEM2, ABOUT_WHY_ITEM3,
    ABOUT_WHY_ITEM4, ABOUT_WHY_ITEM5, ABOUT_WHY_ITEM6,
    ABOUT_FOUNDER_EYEBROW,
    ABOUT_FOUNDER_NAME,
    ABOUT_FOUNDER_ROLE,
    ABOUT_FOUNDER_BIO,
    ABOUT_FOUNDER_AFFILIATION,
    ABOUT_CTA_TITLE,
    ABOUT_CTA_SUBTITLE,
    ABOUT_CTA_PRIMARY,
    ABOUT_CTA_SECONDARY,
} from "../types";

const en_about_us_page = {
    helmet: {
        [ABOUT_US_HELMET_TITLE]: "About Us | Linares Professional Family Services Corp",
        [ABOUT_US_HELMET_DESCRIPTION]: "Meet the bilingual Miami Lakes team behind Linares Professional Family Services — taxes, credit education & coaching, insurance and travel under one trusted roof.",
    },
    section: {
        hero: {
            [ABOUT_HERO_EYEBROW]: "About Linares Pro",
            [ABOUT_HERO_TITLE]: "A family helping families, since day one.",
            [ABOUT_HERO_SUBTITLE]: "We are a bilingual, locally owned team in Miami Lakes. For more than a decade we have helped families navigate taxes, credit, insurance and travel — with honesty, care and zero jargon.",
            [ABOUT_HERO_CTA_PRIMARY]: "Talk to our team",
            [ABOUT_HERO_CTA_SECONDARY]: "Explore our services",
        },
        stats: {
            [ABOUT_STATS_YEARS_VALUE]: "10+",
            [ABOUT_STATS_YEARS_LABEL]: "Years serving Miami",
            [ABOUT_STATS_FAMILIES_VALUE]: "5,000+",
            [ABOUT_STATS_FAMILIES_LABEL]: "Families helped",
            [ABOUT_STATS_SERVICES_VALUE]: "5",
            [ABOUT_STATS_SERVICES_LABEL]: "Services under one roof",
            [ABOUT_STATS_LANGUAGES_VALUE]: "2",
            [ABOUT_STATS_LANGUAGES_LABEL]: "Languages spoken fluently",
        },
        story: {
            [ABOUT_STORY_EYEBROW]: "Our story",
            [ABOUT_STORY_TITLE]: "Built on trust, one family at a time.",
            [ABOUT_STORY_P1]: "Linares Professional Family Services was born out of a simple frustration: families in our community were being passed from one office to another for every life document, every form, every question. We knew there had to be a better way.",
            [ABOUT_STORY_P2]: "Today, our Miami Lakes office is a one-stop home for the paperwork that shapes a family's future — taxes, credit education & coaching, insurance and travel. Every client gets the same thing: a real person, a clear plan, and follow-through.",
            [ABOUT_STORY_P3]: "We measure success by the families who keep coming back — and by the friends and relatives they send our way.",
            [ABOUT_STORY_IMAGE_ALT]: "The Linares Professional Family Services team welcoming a client",
        },
        values: {
            [ABOUT_VALUES_EYEBROW]: "What drives us",
            [ABOUT_VALUES_TITLE]: "Four values, in everything we do.",
            [ABOUT_VALUES_SUBTITLE]: "These are not posters on the wall — they are how we answer the phone, prepare every file, and look our clients in the eye.",
            [ABOUT_VALUE_TRUST_TITLE]: "Trust before transactions",
            [ABOUT_VALUE_TRUST_DESC]: "We tell you what is possible, what is not, and what it will really cost — before you commit to anything.",
            [ABOUT_VALUE_BILINGUAL_TITLE]: "Bilingual, end-to-end",
            [ABOUT_VALUE_BILINGUAL_DESC]: "From the first call to the final signature, you can switch between English and Spanish at any moment without losing nuance.",
            [ABOUT_VALUE_FAMILY_TITLE]: "Family-first service",
            [ABOUT_VALUE_FAMILY_DESC]: "We treat every household like our own, because we know the paperwork in front of us often shapes the years ahead.",
            [ABOUT_VALUE_EXPERTISE_TITLE]: "Deep, current expertise",
            [ABOUT_VALUE_EXPERTISE_DESC]: "Tax codes, USCIS rules and credit-bureau policies change constantly. Continuous training is part of our weekly routine, not an afterthought.",
        },
        why: {
            [ABOUT_WHY_EYEBROW]: "Why families choose us",
            [ABOUT_WHY_TITLE]: "The Linares difference",
            [ABOUT_WHY_ITEM1]: "Free, no-obligation first consultation for every service.",
            [ABOUT_WHY_ITEM2]: "Real human follow-up — no chatbots, no phone trees.",
            [ABOUT_WHY_ITEM3]: "Five services under one roof — no being passed around.",
            [ABOUT_WHY_ITEM4]: "Transparent pricing, explained before you sign.",
            [ABOUT_WHY_ITEM5]: "Document confidentiality protected at every step.",
            [ABOUT_WHY_ITEM6]: "Walk-ins welcome at our Miami Lakes office.",
        },
        founder: {
            [ABOUT_FOUNDER_EYEBROW]: "Meet our founder",
            [ABOUT_FOUNDER_NAME]: "Ana Linares",
            [ABOUT_FOUNDER_ROLE]: "Founder & Director, Linares Pro Corp Family Service",
            [ABOUT_FOUNDER_BIO]: "Ana Linares has assisted hundreds of families and small businesses throughout South Florida by providing professional tax preparation, business support, insurance guidance, credit education and coaching services, notary services, travel assistance, and family resource solutions. Through trusted partnerships and affiliated service providers, clients also have access to additional specialized services tailored to their individual needs.",
            [ABOUT_FOUNDER_AFFILIATION]: "Immigration document preparation and related services are offered through our affiliated company, E&W MultiService LLC.",
        },
        cta: {
            [ABOUT_CTA_TITLE]: "Let's start a conversation.",
            [ABOUT_CTA_SUBTITLE]: "Tell us what your family needs — we'll point you in the right direction, no obligation.",
            [ABOUT_CTA_PRIMARY]: "Book a free consultation",
            [ABOUT_CTA_SECONDARY]: "Call the office",
        },
    },
};

export default en_about_us_page;
